/* eslint-disable */
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var ViewModel = function (model) {
  Base.call(this);
  this.selectedEntityCount(model.get('selectedEntityCount'));
  this.showPreviewButton(false);
  this.showPanel = ko.observable(true);
  this.titleText = ko.computed(function () {
    return i18n.getString('label_association_panel_title', this.selectedEntityCount());
  }, this);
  this._inlineErrors = ko.observable([]);
  this.inlineErrors = ko.computed({
    read: function () {
      return this._inlineErrors();
    },
    write: function (value) {
      var err = value.map(function (errorObject) {
        var errorKey = errorObject.Errors[0];
        var entityName = errorObject.EntityKey[0].Value;
        return {
          error: i18n.getString('Error_Campaign_API_' + errorKey),
          name: entityName
        };
      });
      this._inlineErrors(err);
    }
  }, this);
  this.validate = function () {
    this.errorMessage('');
    if (this.selectedEntityCount() === 0) {
      alert(i18n.getString('Grid_RowSelectionRequired'));
      return false;
    }
    return true;
  };
};
export default ViewModel;

